import { useEffect, useState } from 'react';

import NextImage from 'next/image';
import { useRouter } from 'next/router';

import ROUTES from 'config/routes';
import ImageLink from 'shared/components/ImageLink';
import NextLink from 'shared/components/NextLink';
import { useDarkMode } from 'shared/hooks/useDarkMode';
import useLanguageCookie from 'shared/hooks/useLanguageCookie';
import useTranslation from 'shared/hooks/useTranslation';

import GeoIp from '../GeoIp';
import LanguageSelector from '../NavBar-v2/LanguageSelector';
import { ExpandableMenuItem } from './components/ExpandedContent/ExpandableMenuItem/ExpandableMenuItem';
import {
    SolutionsExpandedContent
} from './components/ExpandedContent/SolutionsExpandedContent/SolutionsExpandedContent';
import { WhyUsExpandedContent } from './components/ExpandedContent/WhyUsExpandedContent/WhyUsExpandedContent';
import { LinkButton } from './components/LinkButton/LinkButton';
import { MobileMenu } from './components/MobileMenu/MobileMenu';
import { NavLink } from './components/NavLink/NavLink';
import { SOLUTIONS_ITEMS, WHY_US_ITEMS } from './data/SubMenuItems';
import styles from './Navbar.module.scss';

export default function NavBar(): JSX.Element {
  const { t, lang } = useTranslation('common');
  const { theme: themeMode } = useDarkMode();
  const languageCookie = useLanguageCookie();
  const [isLanguageSelector, setLanguageSelector] = useState(false);
  const { pathname } = useRouter();
  useEffect(() => {
    if (pathname === ROUTES.HOME) {
      setLanguageSelector(true);
    } else {
      setLanguageSelector(false);
    }
  }, [pathname]);
  return (
    <>
      {languageCookie ? null : <GeoIp />}
      <header className={styles.header}>
        <div className={styles.nav}>
          <div className={styles.navContent}>
            <NextLink href={ROUTES.HOME}>
              <div className={styles.logo}>
                <NextImage
                  priority
                  src={`/img/logos/logo-trustmate-2022-${themeMode}.svg`}
                  width={308}
                  height={64}
                  alt="logo"
                />
              </div>
            </NextLink>
            <div className={styles.menu}>
              <div>
                <ExpandableMenuItem title={<div className={styles.styledNavLink}>{t('navbar.whyUs.name')}</div>}>
                  <WhyUsExpandedContent />
                </ExpandableMenuItem>
                <ExpandableMenuItem title={<div className={styles.styledNavLink}>{t('navbar.solutions.name')}</div>}>
                  <SolutionsExpandedContent />
                </ExpandableMenuItem>
                <NavLink aTag={true} className={styles.styledNavLink} href={ROUTES.PRICING} passHref>
                  {t('navbar.pricing')}
                </NavLink>
              </div>
              <div>
                <NavLink aTag className={styles.styledNavLink} href={ROUTES.LOG_IN} passHref orange bold>
                  {t('navbar.login')}
                </NavLink>
                <LinkButton aTag className={styles.linkButton} href={ROUTES.REGISTER}>
                  {t('navbar.freeTrial')}
                </LinkButton>
                {isLanguageSelector ? <LanguageSelector /> : null}
                {lang === 'pl' ? (
                  <div className={styles.euWrapper}>
                    <ImageLink
                      withLazyBoundary={false}
                      src="/img/shared/eu-logo.png"
                      alt="eu logo"
                      width={80}
                      height={49}
                      href={ROUTES.EU}
                    />
                  </div>
                ) : null}
              </div>
            </div>
            <div className={styles.mobileMenuWrapper}>
              <MobileMenu solutionItems={SOLUTIONS_ITEMS} whyUsItems={WHY_US_ITEMS} />
            </div>
          </div>
        </div>
      </header>
    </>
  );
}
